import { AxiosResponse } from "axios";
import * as API from "middleware/api";
import {
  DetailPreliquidationBodyParamsType,
  DetailPreliquidationsContentResponseType,
  DetailPreliquidationsInvoiceApiResponseType,
  PreliquidationsApiResponse,
  UploadInvoiceFileMiddlewareType,
  DetailPreliquidationsInvoiceTypesApiResponseType,
  PreliquidationCastParamsMiddlewareType,
  AdjustAmountMiddlewareType,
  DetatilPreliquidationsApiResponse,
  sendAccountinMiddlewareType,
  SendAccountingResultType,
  RejectInvoiceMiddlewareType,
  RejectInvoiceReasonType,
} from "sagas/types/preliquidation";
import { ApiResponse, ApiResponseResult } from "./api";

export const getPreliquidations = (
  params: PreliquidationCastParamsMiddlewareType
): Promise<AxiosResponse<PreliquidationsApiResponse>> =>
  API.get("/ms-admin-rest/api/v1.0/presettlements", params);

export const getDetailInvoice = (
  id: string | undefined
): Promise<AxiosResponse<DetailPreliquidationsContentResponseType>> =>
  API.get(`/ms-admin-rest/api/v1.0/presettlements/${id}/invoice`);

export const putSaveDetailInvoice = (
  presettlementId: string | undefined,
  params: DetailPreliquidationBodyParamsType
): Promise<AxiosResponse<DetailPreliquidationsInvoiceApiResponseType>> =>
  API.put(
    `/ms-admin-rest/api/v1.0/presettlements/${presettlementId}/invoice`,
    params
  );

export const patchApproveDetailInvoice = (
  presettlementId: string | undefined,
  params: DetailPreliquidationBodyParamsType
): Promise<AxiosResponse<DetailPreliquidationsInvoiceApiResponseType>> =>
  API.patch(
    `/ms-admin-rest/api/v1.0/presettlements/${presettlementId}/invoice`,
    params
  );

export const putRejectDetailInvoice = (
  payload: RejectInvoiceMiddlewareType
): Promise<AxiosResponse<DetailPreliquidationsInvoiceApiResponseType>> =>
  API.put(
    `/ms-admin-rest/api/v1.0/presettlements/${payload.presettlementId}/rejected-invoice`,
    payload.reason
  );

export const getDetailInvoiceTypes = (): Promise<
  AxiosResponse<DetailPreliquidationsInvoiceTypesApiResponseType>
> => API.get(`/ms-admin-rest/api/v1.0/fiscal-data/invoice-type`);

export const getRejectedReason = (): Promise<
  AxiosResponse<API.ApiResponseResult<RejectInvoiceReasonType[]>>
> => API.get(`/ms-admin-rest/api/v1.0/fiscal-data/rejected-reasons`);

export const replaceInvoiceFile = (
  params: UploadInvoiceFileMiddlewareType
): Promise<AxiosResponse<ApiResponse<void>>> =>
  API.put(`/ms-admin-rest/api/v1.0/presettlements/${params.id}/invoice/file`, {
    content: params.content,
  });
export const uploadInvoiceFile = (
  params: UploadInvoiceFileMiddlewareType
): Promise<AxiosResponse<ApiResponse<void>>> =>
  API.post(`/ms-admin-rest/api/v1.0/presettlements/${params.id}/invoice/file`, {
    content: params.content,
  });
export const uploadInvoiceFileText = (
  params: UploadInvoiceFileMiddlewareType
): Promise<AxiosResponse<ApiResponse<void>>> =>
  API.post(`/ms-admin-rest/api/v1.0/presettlements/${params.id}/invoice-file-text`, {
    content: params.content,
  });
export const deleteInvoiceFile = (
  id: number
): Promise<AxiosResponse<ApiResponse<void>>> =>
  API.remove(`/ms-admin-rest/api/v1.0/presettlements/${id}/invoice/file`);

export const preliquidationAdjustment = (
  params: AdjustAmountMiddlewareType
) => {
  const { id, callback, ...body } = params;
  return API.post(
    `/ms-admin-rest/api/v1.0/presettlements/${id}/adjustment`,
    body
  );
};
export const getDetailPreliquidations = (
  id: number
): Promise<AxiosResponse<DetatilPreliquidationsApiResponse>> =>
  API.get(`/ms-admin-rest/api/v1.0/presettlements/${id}`);

export const getPreliquidationsExport = (
  params: PreliquidationCastParamsMiddlewareType
): Promise<AxiosResponse<PreliquidationsApiResponse>> => {
  const { limit, offset, ...body } = params;
  return API.get("/ms-admin-rest/api/v1.0/presettlements.csv", body);
};

export const sendAccounting = (
  params: sendAccountinMiddlewareType
): Promise<AxiosResponse<ApiResponseResult<SendAccountingResultType>>> =>
  API.post(`/ms-admin-rest/api/v1.0/presettlements/accounting`, params);
